import React, { useState } from "react";
import { ReactInternetSpeedMeter } from 'react-internet-meter'
// import 'react-internet-meter/dist/index.css'

const SpeedNotification = (props) => {
  const [wifiSpeed, setwifiSpeed] = useState(500);
  const wifiMinSpeed = 200; // 500 Kbs

  return (
    <div className={wifiMinSpeed <= wifiSpeed ? "d-none" : "col d-flex justify-content-center mt-0 mb-0 w-100"} style={{ minHeight: "0px", maxHeight: "68px", fontSize: "0.875rem", textOverflow: "ellipsis", paddingTop: "0.25rem" }}>
      <ReactInternetSpeedMeter
        txtSubHeading=""
        outputType="empty"
        customClassName={"alert-warning"}
        txtMainHeading=""
        pingInterval={30000} // milliseconds 
        thresholdUnit='kilobyte' // "byte" , "kilobyte", "megabyte" 
        threshold={wifiMinSpeed}
        imageUrl="https://firebasestorage.googleapis.com/v0/b/sg-cbtkd.appspot.com/o/images%2FLOGO561675306727975?alt=media&token=2bde707f-6631-401a-9a56-382bf17e6d7c"
        downloadSize="17033"  //bytes
        // callbackFunctionOnNetworkDown={(speed) => console.log(`Internet speed is down ${speed} Kbs`)}
        callbackFunctionOnNetworkDown={(speed) => { return; }}
        callbackFunctionOnNetworkTest={(speed) => setwifiSpeed(speed)}
      // callbackFunctionOnNetworkTest={(speed) => { console.log(`Internet speed is down ${speed} Kbs`); setwifiSpeed(speed); }}
      />
      {wifiMinSpeed <= wifiSpeed ? (
        <div></div>
      ) : (
        <div id="saveToast" className="text-bg-warning ms-0 me-0 mb-0 w-100 rounded-0">
          <div className="pt-1 pb-1">
            <div className="d-flex justify-content-center">
              <span className="d-flex align-middle">
                <span className="material-symbols-outlined">speed</span>
                <span className="ms-2 text-wrap">{"Sua conexão de internet está lenta. Isto pode impedir o uso deste portal."}</span>
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SpeedNotification;
